import { createStore } from "redux";
import storeReducer from "./reducers";

export default createStore(storeReducer);
